<template>
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.4179 9.60898C3.19421 9.60898 2.99009 9.42767 3.00037 9.19066C3.0606 7.80279 3.22933 6.89929 3.70207 6.18456C3.97405 5.77338 4.31189 5.41574 4.70031 5.12782C5.75018 4.34961 7.23125 4.34961 10.1934 4.34961H13.8066C16.7688 4.34961 18.2498 4.34961 19.2997 5.12782C19.6881 5.41574 20.026 5.77338 20.2979 6.18456C20.7706 6.89921 20.9394 7.80259 20.9996 9.1902C21.0099 9.42748 20.8055 9.60898 20.5816 9.60898C19.3344 9.60898 18.3233 10.6793 18.3233 11.9996C18.3233 13.3199 19.3344 14.3902 20.5816 14.3902C20.8055 14.3902 21.0099 14.5717 20.9996 14.809C20.9394 16.1966 20.7706 17.1 20.2979 17.8147C20.026 18.2258 19.6881 18.5835 19.2997 18.8714C18.2498 19.6496 16.7688 19.6496 13.8066 19.6496H10.1934C7.23125 19.6496 5.75018 19.6496 4.70031 18.8714C4.31189 18.5835 3.97405 18.2258 3.70207 17.8147C3.22933 17.0999 3.0606 16.1964 3.00037 14.8086C2.99009 14.5715 3.19421 14.3902 3.4179 14.3902C4.66511 14.3902 5.67616 13.3199 5.67616 11.9996C5.67616 10.6793 4.66511 9.60898 3.4179 9.60898Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 14.25L14.25 9.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9.75 9.75H9.7601M14.2399 14.25H14.25"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
<script setup lang="ts"></script>
<style lang=""></style>
